(function() {
  "use strict";
  angular.module("marketPlace.lodash", []);
})();
